import React from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { clearProposal } from "../../actions/proposal";

import "./AlertCurrentUpdating.scss";

const AlertCurrentUpdating = ({ currentUpdating }) => {
  const { studentSelected } = currentUpdating;
  const dispatch = useDispatch();

  const handleClick = () => {
    // dispatch(removeProposalfromUpdating());
    // console.log()
    dispatch(clearProposal());
  };

  return (
    <div className="alert-updating">
      <div className="alert-updating__wrapper">
        <div className="alert-updating__heading">
          <h2 className="title-gray-black-18">
            You are updating a proposal for{" "}
            <span className="title-gray-bold-20">
              {studentSelected.studentname} {studentSelected.studentlastname}
            </span>
          </h2>
          <p className="paragraph-gray-reg-16">Do you want to continue?</p>
        </div>
        <div className="alert-updating__buttons">
          <NavLink
            to={`/creator/proposals/section-proposal/${currentUpdating._id}`}
          >
            <button className="btn-primary">Continue</button>
          </NavLink>
          <button className="btn-secondary" onClick={handleClick}>
            Create new
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertCurrentUpdating;
